import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import InputAdornment from "@material-ui/core/InputAdornment";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
import { useForm } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import PersonIcon from "@material-ui/icons/Person";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import EventIcon from "@material-ui/icons/Event";
//import UserPaymentMethodsAdd from "../UserProfile/UserPaymentMethodsAdd";
import CardPaymentList from "./CardPaymentList";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import Conekta from "../../../../../conekta/ConektaHelper";
import { showSnackbar } from "../../../../../data-store/actions/organizers-actions";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";

import { useTracking } from "react-tracking";
import { useLocation } from "react-router-dom";
import { updateEventObject } from "../../../../../data-store/actions/events-actions";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "black",
  },
  paper: {
    padding: "20px",
    backgroundColor: "#283747",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
  },
  buttons: {
    margin: 30,
    width: "250px",
    color: "black",
  },
}));

export default function CardPayment(props) {
  let {
    callback,
    order,
    test,
    currency,
    currencyBase,
    currentOrder,
    eventDetail,
  } = props;
  const dispatch = useDispatch();
  const userID = useSelector((state) => state.atlete.userID);
  const athleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const registryParticipantKey = useSelector(
    (state) => state.registry.registryParticipantKey
  );

  const registryConfigurationData = useSelector(
    (state) => state.registry.registryConfiguration
  );
  const { trackEvent } = useTracking();
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const query = useQuery();

  const classes = useStyles();
  const { t } = useTranslation("inscripcion");
  const { register, handleSubmit, errors, watch } = useForm();
  const [sending, setSending] = useState(false);
  // const [cardNumber, setCardNumber] = useState(null);
  // const [cardOwner, setCardOwner] = useState(null);
  // Lee el número de tarjeta en vivo mientras lo teclean
  const cardNumberLive = watch("cardNumber", "") || "";

  // Helper: primeros 8 dígitos “limpios”
  const bin8 = useMemo(() => cardNumberLive.replace(/\D/g, "").slice(0, 8), [cardNumberLive]);
  // Convierte a Set (lookup O(1))
  const banorteBinsSet = useMemo(() => new Set(banorteBins.map(String)), []);
  // ¿Coincide con Banorte? (solo evaluamos cuando ya hay 8 dígitos)
  const isBanorte = useMemo(() => bin8.length === 8 && banorteBinsSet.has(bin8), [bin8, banorteBinsSet]);

  if ((eventDetail?.iDEvento === 572 || eventDetail?.iDEvento === 0) && bin8.length === 8 && isBanorte) {
    console.log("ORDEN", order, currentOrder, registryParticipantKey)
    // bin example 40231800


    order = addBanorteDiscount(order, registryConfigurationData.configuracion.formasDePago.comisionGlobal, true, getDiscount(currentOrder.modalidad))
    console.log("ORDEN new", order, currentOrder, registryParticipantKey)

  } else if ((eventDetail?.iDEvento === 572 || eventDetail?.iDEvento === 0) && bin8.length === 8 && !isBanorte) {
    console.log("ORDEN No Banorte", order, currentOrder, registryParticipantKey)
    order = addBanorteDiscount(order, registryConfigurationData.configuracion.formasDePago.comisionGlobal, false, 0)
    console.log("ORDEN No Banorte new ", order, currentOrder, registryParticipantKey)

  }


  function getDiscount(distance) {
    const discountByDistancAndMoth = {
      11: { 1: -100, 2: -100, 3: -50, 4: -50 },
      12: { 1: -50, 2: -50, 3: -50, 4: -50 }
    };

    const month = new Date().getMonth() + 1; // 1–12

    // Si no es noviembre (11) ni diciembre (12)
    if (month !== 11 && month !== 12) return 0;

    // Obtener el objeto del mes
    const monthData = discountByDistancAndMoth[month];

    // Si no existe la distancia, devolver 0
    if (!monthData || monthData[distance] == null) return 0;

    return monthData[distance];
  }

  /**
 * Agrega o quita el descuento BANORTE y recalcula la comisión.
 *
 * @param {Array} orderItems - Arreglo de items de la orden.
 * @param {number} comisionGlobal - Porcentaje de comisión (ej: 0.07 o 7).
 * @param {boolean} agregar - Si true agrega/asegura el descuento, si false lo quita.
 * @returns {Array} Nueva lista de items con comisión recalculada.
 */
  function addBanorteDiscount(orderItems, comisionGlobal, agregar, amount) {
    // Trabajamos con una copia para no mutar el arreglo original
    let items = orderItems.map(item => ({ ...item }));

    const DISCOUNT_CODE = "códigoDescuento";
    const COMMISSION_CODE = "comision";

    // Normalizar porcentaje (acepta 0.07 o 7)
    const rate = comisionGlobal > 1 ? comisionGlobal / 100 : comisionGlobal;

    // 1) Agregar o quitar item de descuento BANORTE
    if (agregar) {
      const alreadyHasDiscount = items.some(item => item.code === DISCOUNT_CODE);

      if (!alreadyHasDiscount) {
        items.push({
          code: DISCOUNT_CODE,
          description: t("tarjeta.codigoDescuento"),
          extraData: {
            code: "BANORTE",
          },
          name: t("tarjeta.codigoDescuento"),
          precioKey: "",
          quantity: 1,
          // Ajusta este valor si el descuento cambia
          unit_price: amount,
        });
      }
    } else {
      // Quitar cualquier item de descuento BANORTE
      items = items.filter(item => item.code !== DISCOUNT_CODE);
    }

    // 2) Calcular la base sobre la que se cobra la comisión
    //    "total de ítems diferentes a la misma comisión"
    const baseTotal = items
      .filter(item => item.code !== COMMISSION_CODE)
      .reduce((sum, item) => {
        const qty = item.quantity != null ? item.quantity : 1;
        return sum + item.unit_price * qty;
      }, 0);

    const nuevaComision = parseFloat((baseTotal * rate).toFixed(2));

    // 3) Actualizar (o crear) el item de comisión
    let tieneComision = false;

    items = items.map(item => {
      if (item.code === COMMISSION_CODE) {
        tieneComision = true;
        return {
          ...item,
          unit_price: nuevaComision,
        };
      }
      return item;
    });

    // Si no existe el item de comisión lo creamos al final
    if (!tieneComision) {
      items.push({
        code: COMMISSION_CODE,
        description: t("comisionDescripcion"),
        name: t("comisionNombre"),
        precioKey: "",
        quantity: 1,
        unit_price: nuevaComision,
      });
    }

    return items;
  }


  function onSubmit(data) {
    if (eventDetail?.iDEvento === 572 || eventDetail?.iDEvento === 0) {
      // guardo la orden ajustada antes de hacer el pago
      dispatch(updateEventObject("evento_" + eventDetail.iDEvento, "/inscritos/listadoInscritos/" + registryParticipantKey + "/order/", order));
    }
    // setCardNumber(data.cardNumber);
    // setCardOwner(data.cardOwner);
    setSending(true);
    // console.log("data", data);
    // console.log("data", cardNumber);
    // console.log("data", sending);

    tokenizar(data);
  }

  function tokenizar(data) {
    const cardNumber = data.cardNumber;
    const cardOwner = data.cardOwner;

    function successCallback(token) {
      console.log("success", cardOwner);
      console.log(token);
      var amount = 0;
      var items = order;
      var conektaItems = [];
      for (var i in items) {
        var price = items[i].unit_price;
        price =
          Math.round(parseFloat(price * currencyBase.cambioAPeso) * 100) / 100;

        var item = {
          name: items[i].name,
          quantity: items[i].quantity,
          unit_price: Math.round(price * 100),
        };

        amount =
          Math.round(
            (parseFloat(amount) +
              parseFloat(price) * parseFloat(items[i].quantity)) *
            100
          ) / 100;
        console.log("amount " + amount);
        conektaItems.push(item);
      }

      var last4 = cardNumber.substring(
        cardNumber.length - 4,
        cardNumber.length
      );

      var jsonDatos = {
        correo: currentOrder.correo,
        token: token.id,
        nombres: cardOwner,
        telefono: currentOrder.telefono,
        tipoPago: "card",
        inscritoKey: registryParticipantKey,
        eventoIndex: "evento_" + eventDetail.iDEvento,
        last4: last4,
        brand: "",
        amount: amount,
        jsonItems: conektaItems,
      };

      console.log(jsonDatos);

      var headers = {
        headers: { "Access-Control-Allow-Origin": true },
      };

      axios
        .post(
          "https://us-central1-kmetasfirebase.cloudfunctions.net/conektaCargoV2",
          jsonDatos,
          headers
        )
        .then((res) => {
          console.log(res);
          callback(true, false);
          dispatch(showSnackbar(true, t("pago.pagoExitoso"), 4000));

          const tkl = query.get("tkl");

          trackEvent({
            eventName: "evento_" + eventDetail.iDEvento,
            typeEvent: "Purchase",
            params: {
              label: "Purchase",
              tkl: tkl || "direct",
              order: order,
              eventName: eventDetail.nombreEvento,
              facebookPixel: eventDetail.facebookPixel || false,
              gaId: eventDetail.gaId || false,
            },
          });

          setSending(false);
        })
        .catch((error) => {
          console.log(error);
          setSending(false);
          var errorTexto = "";
          if (error.responseJSON !== undefined) {
            for (var i in error.responseJSON.details) {
              errorTexto =
                errorTexto + error.responseJSON.details[i].message + " - ";
            }
          }
          //callback(false);
          dispatch(
            showSnackbar(
              true,
              t("oxxoPayment.errorProcesandoPago", { detalle: errorTexto }),
              2000
            )
          );
        });
    }

    function errorCallback(err) {
      // err keys: object, type, message, message_to_purchaser, param, code
      console.log("error tokenizando " + JSON.stringify(err));
      console.log(err);
      dispatch(
        showSnackbar(
          true,
          t("tarjeta.errorPrefijo") + err.message_to_purchaser,
          2000
        )
      );

      //TODO: mostrar aqui error al tokenizar, detalle de numero o datos
      setSending(false);
    }

    var validarConekta = true;

    let production = true;

    if (test) {
      production = false;
    }
    Conekta.initConekta(production);

    const expirationMonth = data.month / 1;
    const expirationYear = data.year / 1;
    console.log(expirationMonth);
    console.log(expirationYear);

    if (!Conekta.validateCardNumber(data.cardNumber)) {
      validarConekta = false;

      dispatch(showSnackbar(true, t("tarjeta.revisaNumeroTarjeta"), 4000));
    }
    if (!Conekta.validateCvc(data.securityCode)) {
      validarConekta = false;
      dispatch(showSnackbar(true, t("tarjeta.revisaCodigoSeguridad"), 4000));
    }
    if (!Conekta.validateExpirationDate(expirationMonth, expirationYear)) {
      validarConekta = false;
      dispatch(showSnackbar(true, t("tarjeta.revisaFechaExpiracion"), 4000));
    }

    console.log("validar conekta " + validarConekta);

    if (validarConekta) {
      Conekta.tokenize(
        data.cardNumber,
        data.cardOwner,
        expirationMonth,
        expirationYear,
        data.securityCode,
        successCallback,
        errorCallback
      );
    } else {
      setSending(false);
    }
  }

  function esBanorte(cardNumber) {
    const clean = String(cardNumber).replace(/\D/g, ""); // quita espacios o guiones
    return banorteBins.some(bin => clean.startsWith(String(bin)));
  }

  return (
    <Grid
      container
      direction="row"
      style={{
        height: "auto",
        width: "100%",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        style={{ padding: "10px", textAlign: "center" }}
      >
        <Typography color="primary" component="h1" variant="h3">
          {t("tarjeta.tituloTarjeta")}
        </Typography>
        <Typography color="primary" component="h1" variant="h6">
          {t("tarjeta.ingresaDatos")}
        </Typography>
        {eventDetail.iDEvento === 572 &&
          <Typography color="primary" component="h1" variant="h6">
            {t("tarjeta.precioEspecialBanorte")}
          </Typography>

        }
      </Grid>
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        style={{ width: "100%" }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          alignItems={"left"}
          style={{ margin: "40px" }}
        >
          <Typography color="primary" variant="h5">
            {t("tarjeta.nombrePropietario")}
          </Typography>
          <TextField
            style={{ width: "100%" }}
            helperText={errors.cardOwner ? t("tarjeta.campoRequerido") : null}
            InputProps={{
              style: {
                marginBottom: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{}} />
                </InputAdornment>
              ),
            }}
            defaultValue={currentOrder.nombres + " " + currentOrder.apellidos}
            error={Boolean(errors.cardOwner)}
            fullWidth
            inputRef={register({ required: true })}
            name="cardOwner"
          />
          <Typography color="primary" variant="h5">
            {t("tarjeta.numeroDeTarjeta")}
          </Typography>
          <TextField
            style={{ width: "100%" }}
            helperText={errors.cardNumber ? t("tarjeta.campoRequerido") : null}
            InputProps={{
              style: {
                marginBottom: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <CreditCardIcon style={{}} />
                </InputAdornment>
              ),
            }}
            error={Boolean(errors.cardNumber)}
            fullWidth
            inputRef={register({
              required: true,
              minLength: 10,
            })}
            name="cardNumber"
          />



          {eventDetail?.iDEvento === 572 && bin8.length === 8 && isBanorte && (
            <div style={{ marginTop: 8 }}>
              <Typography style={{ fontWeight: 700 }} color="primary" variant="subtitle1">
                {t("tarjeta.descuentoBanorteAplicado", {
                  descuento: getDiscount(currentOrder.modalidad) * -1,
                })}
              </Typography>
              <Typography color="primary" variant="h4">
                {t("tarjeta.montoTotalActual", {
                  monto: order.reduce(
                    (acc, i) => acc + i.unit_price * (i.quantity ?? 1),
                    0
                  ),
                })}
              </Typography>
            </div>
          )}

          <Typography color="primary" variant="h5">
            {t("tarjeta.fechaDeVencimiento")}
          </Typography>
          <TextField
            label={t("tarjeta.mes")}
            style={{ width: "50%" }}
            helperText={errors.month ? t("tarjeta.campoRequerido") : null}
            InputProps={{
              style: {
                marginBottom: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <EventIcon style={{}} />
                </InputAdornment>
              ),
            }}
            defaultValue={1}
            error={Boolean(errors.month)}
            fullWidth
            inputRef={register({ required: true, min: 1, max: 12 })}
            name="month"
            type="number"
          />
          <TextField
            label={t("tarjeta.anio")}
            style={{ width: "50%" }}
            helperText={errors.year ? t("tarjeta.campoRequerido") : null}
            InputProps={{
              style: {
                marginBottom: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <EventIcon style={{}} />
                </InputAdornment>
              ),
            }}
            defaultValue={2021}
            error={Boolean(errors.year)}
            fullWidth
            inputRef={register({ required: true, min: 2020, max: 2050 })}
            name="year"
            type="number"
          />
          <Typography color="primary" variant="h5">
            {t("tarjeta.codigoDeSeguridad")}
          </Typography>

          <TextField
            label="CVC"
            style={{ width: "100%" }}
            helperText={errors.securityCode ? t("tarjeta.campoRequerido") : null}
            InputProps={{
              style: {
                marginBottom: 15,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <VerifiedUserIcon color="secondary" />
                </InputAdornment>
              ),
            }}
            defaultValue={""}
            error={Boolean(errors.securityCode)}
            fullWidth
            inputRef={register({ required: true, min: 0, max: 9999 })}
            name="securityCode"
            type="number"
          />
          {sending && (
            <Grid item xs={12} sm={12}>
              <LinearProgress />
            </Grid>
          )}
          {!sending && (
            <Button
              type="submit"
              style={{ width: "100%" }}
              color="primary"
              variant="contained"
            >
              {t("tarjeta.realizarElPago")}
            </Button>
          )}

          <Grid item xs={12} sm={12} style={{ margin: "20px" }}>
            <Typography color="secondary" variant="p">
              {t("tarjeta.notaConfirmacion")}
            </Typography>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
}

const banorteBins = [
  40231800,
  40231801,
  40231810,
  40231850,
  40231880,
  40231879,
  40231879,
  42598100,
  42598101,
  42598102,
  42598103,
  42598104,
  42598105,
  42598110,
  42598180,
  42598200,
  42598210,
  42598280,
  42598210,
  42598280,
  42598290,
  46459900,
  49134100,
  49134101,
  49134102,
  49134103,
  49134104,
  49134105,
  49134110,
  49134179,
  49134180,
  49136600,
  49136601,
  49136610,
  49136617,
  49136680,
  49137100,
  49137110,
  49137117,
  49137180,
  49137500,
  49137510,
  49137500,
  49137580,
  49137600,
  49137680,
  49158600,
  49315700,
  49315710,
  49315745,
  49315780,
  49315791,
  49315701,
  49315702,
  49315790,
  49315800,
  49315801,
  49315802,
  49315803,
  49315804,
  49315805,
  49315840,
  49317200,
  49317210,
  49317280,
  49317299,
  49317300,
  49317310,
  49317380,
  51274500,
  51274580,
  54454800,
  54454801,
  54454802,
  54454880,
  54454900,
  54454970,
  54454980,
  54705000,
  54705050,
  54705005,
  54705001,
  54707850,
  54707860,
  54707870,
  54707880,
  54707890,
  54707800,
  54707810,
  54707820,
  54707830,
  54707840,
  54707900,
  54707910,
  54707917,
  54707980,
  54707900,
  54707910,
  54707917,
  54707950,
  54707980,
  54709600,
  54709610,
  54709680,
  54709681,
  54709682,
  54709700,
  54709710,
  54709717,
  54709780,
  54709718,
  54709770,
  55476400,
  55476480
]
